import TeachersPage from "./TeachersPage";

export default TeachersPage;